import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import ServicoEntregaModel from "@/models/servicoEntregaModel";
import ServicoEntregaService from "@/services/servicoEntregaService";

import ListComponentBase from "../listComponentBase";

@Component
export default class ServicoEntregaListComponent extends ListComponentBase<ServicoEntregaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("tipoDescricao", this.$t("__.ts.tipo"), GridColumnType.String),
            new GridColumn("descricao", this.$t("__.ts.gridColumnDescricao"), GridColumnType.String),
            new GridColumn("codigo", this.$t("__.ts.codigo"), GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setProps(new ServicoEntregaService(), "servicoEntrega", "descricao");
    }
}
